import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import styles from "./table.module.css";
import CustomTooltip from 'utils/CustomTooltip';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "#2036C7",
        color: "#fff",
        textAlign: "center",
        padding: "5px",
        fontSize: "12px",
        fontWeight: 400,
        border: "1px solid #EAECF0",
        position: "sticky",
        top: 0,
        zIndex: 10,
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: 12,
        fontWeight: 400,
        padding: "5px",
        color: "#2B2B2B",
        border: "1px solid #EAECF0",
    },
}));

const StyledTableRow = styled(TableRow)({});

const containerStyle = {
        maxHeight: "400px", // Fixed height for scrolling
        overflow: "auto",
    };

const SharedMaintenanceTable = ({ data }) => {
    // Columns where we want rowSpan
    const mergeColumns = ["Line", "Date of PM", "Alert ID"];

    // ✅ New: Group data by Line + Date of PM + Plant
    const getGroupKeys = (row) => `${row.Line}-${row["Date of PM"]}-${row.Plant}`;

    // ✅ Compute rowSpan counts based on combined key
    const rowSpanCounts = {};
    let i = 0;
    while (i < data.length) {
        const groupKey = getGroupKeys(data[i]);
        let count = 1;
        let j = i + 1;
        while (j < data.length && getGroupKeys(data[j]) === groupKey) {
            count++;
            j++;
        }
        rowSpanCounts[i] = count; // Store count for the first row of group
        i = j;
    }

    return (
        <TableContainer className={styles.table} sx={containerStyle}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        {Object.keys(data[0])?.map((col, index) => (
                            <StyledTableCell key={index}>{col}</StyledTableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data?.length > 0 ? (
                        data.map((row, rowIndex) => {
                            const groupKey = getGroupKeys(row);
                            const isFirstInGroup =
                                !rowIndex || getGroupKeys(data[rowIndex - 1]) !== groupKey;

                            return (
                                <StyledTableRow key={rowIndex}>
                                    {Object.keys(row).map((col, colIndex) => {
                                        if (mergeColumns.includes(col)) {
                                            if (isFirstInGroup) {
                                                const rowSpan = rowSpanCounts[rowIndex] || 1;
                                                return (
                                                    <StyledTableCell
                                                        key={colIndex}
                                                        rowSpan={rowSpan}
                                                        align="center"
                                                    >
                                                        {row[col]}
                                                    </StyledTableCell>
                                                );
                                            } else {
                                                return null;
                                            }
                                        } else {
                                            if (col === "Alert CBU Description") {
                                                return (
                                                    <StyledTableCell
                                                        key={colIndex}
                                                        align="center"
                                                        className={styles.ellipsisText}
                                                        style={{ maxWidth: "150px" }}
                                                    >
                                                        <CustomTooltip title={row[col]} placement="top">
                                                            {row[col]}
                                                        </CustomTooltip>
                                                    </StyledTableCell>
                                                );
                                            } else {
                                                return (
                                                    <StyledTableCell key={colIndex} align="center">
                                                        {row[col] !== null ? row[col] : "N/A"}
                                                    </StyledTableCell>
                                                );
                                            }
                                        }
                                    })}
                                </StyledTableRow>
                            );
                        })
                    ) : (
                        <StyledTableRow>
                            <StyledTableCell colSpan={Object.keys(data[0]).length} align="center">
                                Data not available...
                            </StyledTableCell>
                        </StyledTableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SharedMaintenanceTable;
